(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sibling-products"] && !Shopify.designMode) return;
  try {
    class SiblingProducts extends HTMLElement {
    constructor() {
      super();
      this.select = this.querySelector('[data-sibling-select]');
      this.init();
    }

    init() {
      if (this.select) {
        this.select.addEventListener('change', this.handleSelectChange.bind(this));
      }
    }

    handleSelectChange(event) {
      const selectedUrl = event.target.value;
      if (selectedUrl) {
        window.location.href = selectedUrl;
      }
    }
  }

  customElements.define('sibling-products', SiblingProducts);
  } catch(e) { console.error(e); }
})();

})();
